// extracted by mini-css-extract-plugin
export default {"wrapper":"LoadingSpinner_wrapper__M9zRd","spinner":"LoadingSpinner_spinner__+PytG","spin":"LoadingSpinner_spin__MtkTJ"};